var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareNewIconn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 0.587489C9.23438 0.746864 9 1.10624 9 1.49999V3.49999H5.5C2.4625 3.49999 0 5.96249 0 8.99999C0 12.5406 2.54688 14.1219 3.13125 14.4406C3.20937 14.4844 3.29688 14.5 3.38438 14.5C3.725 14.5 4 14.2219 4 13.8844C4 13.65 3.86562 13.4344 3.69375 13.275C3.4 12.9969 3 12.45 3 11.5C3 9.84374 4.34375 8.49999 6 8.49999H9V10.5C9 10.8937 9.23125 11.2531 9.59375 11.4125C9.95625 11.5719 10.375 11.5062 10.6687 11.2437L15.6687 6.74374C15.8781 6.55311 16 6.28436 16 5.99999C16 5.71561 15.8812 5.44686 15.6687 5.25624L10.6687 0.756239C10.375 0.490614 9.95312 0.424989 9.59375 0.587489Z",
    fill: "#B5BAD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNewIconn);
export default __webpack_public_path__ + "static/media/share-new-iconn.987b22dce2e2abf4419067586a0b172f.svg";
export { ForwardRef as ReactComponent };